import React, { useEffect, useState } from "react";
import { Button, Card, Input, Space, Table, Tag, Tooltip } from "antd";
import axios from "axios";

import Swal from "sweetalert2";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import ExpenseCategoryModal from "./ExpenseCategoryModal";

export default function ExpenseCategory() {
  const { Search } = Input;
  const [categoryList, setCategoryList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [searchedCategory, setSearchedCategory] = useState(null);
  const [categoryModal, setCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categoryListLoading, setCategoryListLoading] = useState(false);

  const fetchCategoryList = () => {
    setCategoryListLoading(true);
    axios
      .get(`${config.baseUrl}/budget/expense_category_list/`, {
        headers: authHeader(),
        params: {
          page: currentPage,
          search: searchedCategory,
        },
      })
      .then((response) => {
        setCategoryListLoading(false);
        const resData = Array.isArray(response?.data?.results)
          ? response?.data?.results
          : [];
        setCategoryList(resData);
        setTotalItems(response?.data?.count);
      })
      .catch((error) => {
        setCategoryListLoading(false);
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  useEffect(() => {
    fetchCategoryList();
  }, [currentPage, searchedCategory]);

  const handlePageChange = (page) => {
    console.log(page);
    setCurrentPage(page);
  };
  const handleCategoryModal = () => {
    setCategoryModal(!categoryModal);
  };
  const handleSearch = (value) => {
    setSearchedCategory(value);
  };
  const handleDeleteCategory = (record) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${config.baseUrl}/budget/expense_category/${record?.id}/`, {
            headers: authHeader(),
          })
          .then((response) => {
            console.log(response);
            Swal.fire({
              title: "Deleted!",
              text: "Your expense category has been deleted.",
              icon: "success",
            });
            fetchCategoryList();
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: "Error",
              text: error,
              confirmButtonText: "Ok",
              icon: "error",
            });
          });
      }
    });
  };

  const categoryColumn = [
    {
      title: "Date",
      dataIndex: "created_at",
      width: "12%",
      align: "center",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "-"),
    },

    {
      title: "Category",
      dataIndex: "category_name",
      width: "25%",
      render: (text) => <strong>{text || "-"}</strong>,
    },

    {
      title: "Sub Categories",
      width: "33%",
      render: (record) => (
        <Space wrap>
          {record?.sub_categories?.length ? (
            record.sub_categories.map((sub) => (
              <Tag color="blue" key={sub.id}>
                {sub.sub_category_name}
              </Tag>
            ))
          ) : (
            <Tag color="default">No sub categories</Tag>
          )}
        </Space>
      ),
    },

    {
      title: "Action",
      width: "15%",
      align: "center",
      render: (record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              type="primary"
              ghost
              size="small"
              icon={<EditOutlined />}
              onClick={() => {
                setSelectedCategory(record);
                setCategoryModal(true);
              }}
            />
          </Tooltip>

          <Tooltip title="Delete">
            <Button
              danger
              ghost
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => handleDeleteCategory(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
  return (
    <>
      {categoryModal && (
        <ExpenseCategoryModal
          visible={categoryModal}
          modalClose={handleCategoryModal}
          fetchCategoryList={fetchCategoryList}
          data={selectedCategory}
        />
      )}
      <div className="farmerDashboard">
        <div className="dashboardNameSection">
          <h5 style={{ color: "#46604A" }}>EXPENSE CATEGORY</h5>
        </div>
        <div className="farmerDashboardContainer shadow-sm rounded">
          <div className="pt-5" style={{ width: "95%", margin: "auto" }}>
            <div className="shadow-sm p-3">
              <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
                <div>
                  <Search
                    style={{ width: "280px" }}
                    placeholder="Search product ..."
                    allowClear
                    onSearch={handleSearch}
                    enterButton={
                      <Button
                        style={{
                          backgroundColor: "#46604A",
                          borderColor: "#46604A",
                          color: "white",
                        }}
                      >
                        Search
                      </Button>
                    }
                  />
                </div>
                <div>
                  <Button
                    className="d-flex align-items-center gap-2"
                    style={{
                      backgroundColor: "#46604A",
                      borderColor: "#46604A",
                      color: "white",
                    }}
                    onClick={handleCategoryModal}
                  >
                    <PlusOutlined />
                    Expense Category
                  </Button>
                </div>
              </div>
              <Table
                className="border"
                columns={categoryColumn}
                dataSource={categoryList}
                loading={categoryListLoading}
                rowKey={(record, index) => index}
                pagination={{
                  current: currentPage,
                  pageSize: 10,
                  total: totalItems,
                  onChange: handlePageChange,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
